import gql from 'graphql-tag';

import { AlbumFolderEventSettingsFields } from '../../../../../../graphql/fragments/album-folder';

const getAlbumFolderMarketingMaterials = gql`
  query albumFolderMarketingMaterials($albumFolderId: RecordID!) {
    albumFolder(id: $albumFolderId) {
      id
      name
      album_type
      album_subtype
      is_web_gallery
      onboarding_short_url
      joins_enabled
      photo_sharing_mode
      is_demo
      individual_albums
      picture_day_enabled
      org_pay_photo_pricing_enabled
      search_subscription_credits_joins_enabled
      purchased_event_addon_types
      has_video_album
      privacy
      all_photos_mode
      price {
        value
      }
      default_album_delivery_mode
      account {
        id
        username
      }
      marketing_materials(slice: { limit: 999 }) {
        total
        records {
          id
          type
          pdf_url
          image_url

          configuration {
            marketing_material_type
            primary_text_display
            secondary_text_display
            secondary_text_personalized_message
            display_watermark
          }
        }
      }

      event_settings {
        ...AlbumFolderEventSettingsFields
      }
    }
  }
  ${AlbumFolderEventSettingsFields}
`;

export default getAlbumFolderMarketingMaterials;
